import { useMemo } from "react";
import { AlertResponse, AreaHfb, Media } from "../types/media";
import { OngoingTaskLinksResponse } from "../types/taskLink";
import { FilterValue } from "@coworker/apprestructured/src/shared/filters/types/filter";
import { ArticleWithMediaCount } from "../types/article";
import { filterMediasByArticleHfb } from "../Helpers/hfbHelpers";
import { checkEdsFilter } from "../Helpers/filterHelpers";

export const useFilteredMedias = (
  medias: (Media & AreaHfb)[] | undefined,
  alerts: AlertResponse[] | undefined,
  tasks: OngoingTaskLinksResponse,
  selectedMediaTypeTab: string,
  filterValues: FilterValue[],
  articlesFromHfb: ArticleWithMediaCount[] | undefined | null
): Media[] | undefined => {
  return useMemo(() => {
    if (!medias) return [];

    let filteredMedias = medias;

    if (selectedMediaTypeTab !== "allMedia") {
      filteredMedias = filteredMedias.filter(
        (media) => media.mediaType === selectedMediaTypeTab
      );
    }

    filterValues.forEach(({ filterId, value }) => {
      if (!value) return;

      switch (filterId) {
        case "status":
          filteredMedias = filteredMedias.filter(
            (media) => media.active === value
          );
          break;
        case "area":
          filteredMedias = filteredMedias.filter(
            (media) => media.areaHfb === value
          );
          break;
        case "articleHfb":
          filteredMedias = filterMediasByArticleHfb(
            filteredMedias,
            articlesFromHfb
          );
          break;
        case "alerts":
          filteredMedias = filteredMedias.filter((media) => {
            const alert = alerts?.find(
              (a) => String(a.mediaId) === String(media.id)
            );
            const hasOngoingTask = tasks?.tasks?.some(
              (task) => String(task.media_id) === String(media.id)
            );

            if (value === "salesStop") return (alert?.salesStop ?? 0) > 0;
            if (value === "eds") {
              return checkEdsFilter(alert, filterValues);
            }
            if (value === "ongoingTasks") return hasOngoingTask;

            return false;
          });
          break;
        case "sortBy":
          if (value === "newest" || value === "oldest") {
            filteredMedias = [...filteredMedias].sort((a, b) => {
              const timeA = new Date(a.createdAt).getTime();
              const timeB = new Date(b.createdAt).getTime();
              if (timeB !== timeA) return timeB - timeA;
              return String(a.name).localeCompare(String(b.name));
            });
            if (value === "oldest") {
              filteredMedias.reverse();
            }
          } else if (value === "name") {
            filteredMedias = [...filteredMedias].sort((a, b) =>
              a.name.localeCompare(b.name)
            );
          }
          break;
        default:
          break;
      }
    });

    return filteredMedias;
  }, [
    medias,
    selectedMediaTypeTab,
    filterValues,
    alerts,
    tasks,
    articlesFromHfb,
  ]);
};
